const React = require("react");
const {LayoutAuthWithDesc} = require("../../../layouts");
const ButtonAccept = require("../../../dumb/Button/Accept");
const {account$} = require("../../../../emitters/account");

module.exports = (props) => {
  const params = props.params || {};
  return (
    <LayoutAuthWithDesc
      title={(
        <span>
          Account <b className="clr--blue">{decodeURIComponent(params.email || '')}</b> is blocked.
        </span>
      )}
      description={(
        <div>
          Perhaps attempts count to enter a password was exceed
          or the Lunu has detected a strange activity in your account.
          <br/><br/>
          Please, write to our support - <a
          className="cCT dn o70:h"
          href="mailto:support@lunu.io"
          >support@lunu.io</a>.
        </div>
      )}
      control={(
        <ButtonAccept onClick={account$.signOut}>
          Logout
        </ButtonAccept>
      )}
    />
  );
};
